import React, { useMemo } from 'react';
import { useBulkSelectionData, useHandleBulkSelection } from '../../utilities/index-provider/hooks.js';
import { IndexContext, IndexRowContext, IndexSelectionChangeContext } from '../../utilities/index-provider/context.js';

function IndexProvider(_ref) {
  var children = _ref.children,
      passedResourceName = _ref.resourceName,
      loading = _ref.loading,
      onSelectionChange = _ref.onSelectionChange,
      _ref$selectedItemsCou = _ref.selectedItemsCount,
      selectedItemsCount = _ref$selectedItemsCou === void 0 ? 0 : _ref$selectedItemsCou,
      itemCount = _ref.itemCount,
      hasMoreItems = _ref.hasMoreItems,
      condensed = _ref.condensed,
      _ref$selectable = _ref.selectable,
      isSelectableIndex = _ref$selectable === void 0 ? true : _ref$selectable;

  var _useBulkSelectionData = useBulkSelectionData({
    selectedItemsCount: selectedItemsCount,
    itemCount: itemCount,
    hasMoreItems: hasMoreItems,
    resourceName: passedResourceName
  }),
      paginatedSelectAllText = _useBulkSelectionData.paginatedSelectAllText,
      bulkActionsLabel = _useBulkSelectionData.bulkActionsLabel,
      bulkActionsAccessibilityLabel = _useBulkSelectionData.bulkActionsAccessibilityLabel,
      resourceName = _useBulkSelectionData.resourceName,
      selectMode = _useBulkSelectionData.selectMode,
      bulkSelectState = _useBulkSelectionData.bulkSelectState;

  var handleSelectionChange = useHandleBulkSelection({
    onSelectionChange: onSelectionChange
  });
  var contextValue = useMemo(function () {
    return {
      itemCount: itemCount,
      selectMode: selectMode && isSelectableIndex,
      selectable: isSelectableIndex,
      resourceName: resourceName,
      loading: loading,
      paginatedSelectAllText: paginatedSelectAllText,
      hasMoreItems: hasMoreItems,
      bulkActionsLabel: bulkActionsLabel,
      bulkActionsAccessibilityLabel: bulkActionsAccessibilityLabel,
      bulkSelectState: bulkSelectState,
      selectedItemsCount: selectedItemsCount,
      condensed: condensed
    };
  }, [itemCount, selectMode, isSelectableIndex, resourceName, loading, paginatedSelectAllText, hasMoreItems, bulkActionsLabel, bulkActionsAccessibilityLabel, bulkSelectState, selectedItemsCount, condensed]);
  var rowContextValue = useMemo(function () {
    return {
      selectable: isSelectableIndex,
      selectMode: selectMode && isSelectableIndex,
      condensed: condensed
    };
  }, [condensed, selectMode, isSelectableIndex]);
  return (
    /*#__PURE__*/
    React.createElement(IndexContext.Provider, {
      value: contextValue
    },
    /*#__PURE__*/
    React.createElement(IndexRowContext.Provider, {
      value: rowContextValue
    },
    /*#__PURE__*/
    React.createElement(IndexSelectionChangeContext.Provider, {
      value: handleSelectionChange
    }, children)))
  );
}

export { IndexProvider };